export default __webpack_public_path__ + "static/media/FirstSceneBadgeWithoutArrow.6cc1fb91.png";